<script>
  import Icon from '@iconify/svelte';
  import { nextInkAug, nextInkSeed } from '../../lib/ink.js';

  let { icon, count, label } = $props();

  const aug = nextInkAug();
  const seed = nextInkSeed();
</script>

<div class="card flex items-center gap-4 !p-6" data-augmented-ui={aug} data-ink-seed={seed}>
  <div class="ink-stamp ink-stamp-straight w-11 h-11 !p-0 justify-center text-primary-800 text-xl">
    <Icon {icon} />
  </div>
  <div>
    <div class="text-3xl font-display text-primary-900">{count}</div>
    <div class="text-sm text-secondary-600 uppercase tracking-wider">{label}</div>
  </div>
</div>
